export default "__VITE_ASSET__b05ea391__"